import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Collections, Objects, Types} from "components";
import {Button} from "reactstrap";
import UserRoles from "../../../../../constants/UserRoles";
import API from "@beardeddevops/react.api";

const breadcrumbsStatic = [{
	name: 'Videos',
	url: '/videos',
	icon: 'dashboard'
}];

export default class Videos extends Framework.Components.View {

	constructor(props) {
	super(props);
	this.getUserRoles();
}

	getUserRoles = async () => {
		let model = new API.BuildClass(Types.Roles._name, API.RequestType.READ);
		this.read = 'GET_ALL';
		this.data = await model.submit(null, this.read);
		this.setState({
			userRoles: this.data.items,
		});
	}

	render() {
		return(

			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					{this.props.roles.includes(UserRoles.Admin) &&
						<Button onClick={this.toggle('modalVideoAdd')} size={"sm"} color="primary">
							<i className="fa fa-users"/>&nbsp;&nbsp;Add Video
						</Button>
					}
				</Framework.Components.PageBar>

				<Framework.Elements.UniversalModal
					regions={this.props.regions}
					name={"Video"}
					object={Objects.Video}
					history={history}
					objectProps={{isNew: true, userRoles: this.state.userRoles, editable: true}}
					toggle={this.state.modalVideoAdd}
					reportClose={this.reportClose('modalVideoAdd')}
					afterSave={this.refreshPage}
				/>
				<Collections.Videos key={this.state.key} roles={this.props.roles} userRoles={this.state.userRoles}/>
			</div>


		)
	}
}